import * as React from "react";
import styled, { css } from "styled-components";
import FieldTypeIcon from "views/components/sidebar/fields/FieldTypeIcon";
import FieldType from "views/logic/fieldtypes/FieldType";
const ValueContainer = styled.td(
  ({ theme }) => css`
    font-family: ${theme.fonts.family.monospace};
    white-space: pre-wrap;
  `
);
export const LogViewMessageDetailsHeadRow = ({ onSelectAll, allSelected, hideCheckbox }) => /* @__PURE__ */ React.createElement("tr", null, !hideCheckbox && // eslint-disable-next-line jsx-a11y/control-has-associated-label
/* @__PURE__ */ React.createElement("th", null, /* @__PURE__ */ React.createElement("input", { title: "Select all", type: "checkbox", onChange: onSelectAll, checked: allSelected() })), /* @__PURE__ */ React.createElement("th", null, "Type"), /* @__PURE__ */ React.createElement("th", null, "Field"), /* @__PURE__ */ React.createElement("th", null, "Value"));
const TR = styled.tr(
  ({ theme, $highlighted }) => $highlighted && css`
      &:not(:hover) {
        background-color: ${theme.colors.variant.lightest.primary}!important;
      }
    `
);
const LogViewMessageDetailsRow = ({
  field,
  value,
  type,
  onSelect,
  selected,
  hideCheckbox,
  renderFieldName = (fieldName) => /* @__PURE__ */ React.createElement(React.Fragment, null, fieldName),
  renderFieldValue = (_fieldName, _fieldType, fieldValue) => /* @__PURE__ */ React.createElement(React.Fragment, null, fieldValue),
  isFavorite = false
}) => {
  const fieldType = type != null ? type : FieldType.Unknown;
  return /* @__PURE__ */ React.createElement(TR, { key: field, $highlighted: isFavorite }, !hideCheckbox && // eslint-disable-next-line jsx-a11y/control-has-associated-label
  /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
    "input",
    {
      title: `${selected ? "Remove from" : "Add to"} table`,
      onChange: onSelect,
      type: "checkbox",
      checked: selected
    }
  )), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(FieldTypeIcon, { type: fieldType })), /* @__PURE__ */ React.createElement("td", null, renderFieldName(field, fieldType)), /* @__PURE__ */ React.createElement(ValueContainer, null, renderFieldValue(field, fieldType, value)));
};
export default LogViewMessageDetailsRow;
